import React from 'react'
import { message } from 'antd'
import './index.scss'
import LoginForm from './LoginForm'
import store from '../../store'
import { login } from '../../api'

interface IState {
    loading: boolean
}

class Login extends React.Component<any, IState> {
    public state = {
        loading: false,
    }
    public handleLogin = async (username: string, pasword: string) => {
        try {
            this.setState({loading: true})
            const res: any = await login(username, pasword)
            if (res.code === 0) {
                const { username, roles, token } = res.data
                if (roles.length === 0) {
                    message.warn('The current user has not been granted any roles. Please contact the administrator to assign a role before logging in.', 6)
                    return
                }
                store.authStore.loginSuccess(username, roles, token)
                const { history } = this.props
                history.push('/')
            } else {
                message.warn(res.msg)
            }
        } catch (error) {
            message.error(error.message)
        }
        this.setState({loading: false})
    }
    public render() {
        const { loading } = this.state
        return (
            <div className='login'>
                <div className='login-wrap'>
                    <div className='login-logo'>
                        <embed src='/imgs/logo.svg' />
                        <p>Contract Management System</p>
                    </div>
                    <LoginForm loading={loading} onSuccess={this.handleLogin} />
                </div>
            </div>
        )
    }
}

export default Login
